// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
export const addServicToRecentServices = (
  serviceManagerSlug,
  serviceSlug,
  name,
  processedRecentServicesBySlug,
  recentServices
) => {
  const serviceManager = processedRecentServicesBySlug[serviceManagerSlug]
  const service = processedRecentServicesBySlug[serviceSlug]

  if (serviceManager && !service) {
    processedRecentServicesBySlug[serviceSlug] = serviceManager.map(
      (serviceRegion) => {
        const localStorageService = recentServices.find(
          (rs) => rs?.serviceSlug === serviceSlug && rs?.utc
        )
        const utc = localStorageService
          ? new Date(localStorageService.utc).toISOString()
          : null

        return {
          ...serviceRegion,
          slug: serviceSlug,
          name,
          ...(utc !== null ? { utc } : {})
        }
      }
    )
  }
}
